<div class="number-input-container">
  <mat-form-field
    [hideRequiredMarker]="hideRequiredMarker"
    [floatLabel]="floatLabel"
    [style.width]="size"
    class="number-input-field"
  >
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      type="number"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.min]="min ?? null"
      [attr.max]="max ?? null"
      [step]="step"
      [ngModel]="value"
      (ngModelChange)="onInputChanged($event)"
      [attr.data-lpignore]="disableLastPass ? 'true' : null"
      [attr.autocomplete]="disableLastPass ? 'new-password' : null"
      class="number-input"
    />
    <div matSuffix class="spinner-buttons">
      <button
        type="button"
        class="spinner-button spinner-up"
        (click)="increment()"
        [disabled]="disabled || readonly"
        tabindex="-1"
      >
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 0L14 10H0L7 0Z" class="arrow-fill"/>
        </svg>
      </button>
      <button
        type="button"
        class="spinner-button spinner-down"
        (click)="decrement()"
        [disabled]="disabled || readonly"
        tabindex="-1"
      >
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10L0 0H14L7 10Z" class="arrow-fill"/>
        </svg>
      </button>
    </div>
  </mat-form-field>
</div>
